var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
import isNotStyledSystemProp from "@styled-system/should-forward-prop";

// src/styled.ts
var styled_exports = {};
__export(styled_exports, {
  default: () => defaultStyled
});
__reExport(styled_exports, styled_components_star);
import styled from "styled-components";
import * as styled_components_star from "styled-components";
var defaultStyled = typeof styled === "function" ? styled : styled.default;

// src/index.ts
export * from "styled-components";
function shouldForwardProp(prop, isValidAttr, elementToBeCreated) {
  if (typeof elementToBeCreated !== "string") {
    return true;
  }
  return isValidAttr(prop) || isNotStyledSystemProp(prop);
}
var styledWithForwardProp = (tag) => {
  return defaultStyled(tag).withConfig({
    shouldForwardProp
  });
};
var styled2 = styledWithForwardProp;
Object.keys(defaultStyled).forEach((tag) => {
  styled2[tag] = styledWithForwardProp(tag);
});
var src_default = styled2;
export {
  src_default as default,
  styled2 as styled
};
